import { configureStore, combineReducers } from "@reduxjs/toolkit";

import { authApi } from "./api/authApi";
import { onboardingApi } from "./api/onboardingApi";
import onboardingSlice from "./slices/onboardingSlice";
import { homeApi } from "./api/homeApi";
import homeSlice from "./slices/homeSlice";
import modalSlice from "./slices/modalSlice";
import { userApi } from "./api/userApi";
import { eventApi } from "./api/eventApi";
import userSlice from "./slices/userSlice";
import chatSlice from "./slices/chatSlice";
import { leaderboardApi } from "./api/leaderboardApi";
import eventSlice from "./slices/eventSlice";
import { academyApi } from "./api/academyApi";
import { searchApi } from "./api/searchApi";
import searchSlice from "./slices/searchSlice";
import academySlice from "./slices/academySlice";
import { walletApi } from "./api/walletApi";
import { toolsApi } from "./api/toolsApi";
import { moneyApi } from "./api/moneyApi";
import { orderApi } from "./api/orderApi";

const rootReducer = combineReducers({
  [authApi.reducerPath]: authApi.reducer,
  [onboardingApi.reducerPath]: onboardingApi.reducer,
  [homeApi.reducerPath]: homeApi.reducer,
  [academyApi.reducerPath]: academyApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [eventApi.reducerPath]: eventApi.reducer,
  [leaderboardApi.reducerPath]: leaderboardApi.reducer,
  [searchApi.reducerPath]: searchApi.reducer,
  [walletApi.reducerPath]: walletApi.reducer,
  [toolsApi.reducerPath]: toolsApi.reducer,
  [moneyApi.reducerPath]: moneyApi.reducer,
  [orderApi.reducerPath]: orderApi.reducer,
  onboarding: onboardingSlice,
  home: homeSlice,
  modal: modalSlice,
  academy: academySlice,
  user: userSlice,
  chat: chatSlice,
  event: eventSlice,
  search: searchSlice,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      onboardingApi.middleware,
      homeApi.middleware,
      userApi.middleware,
      academyApi.middleware,
      leaderboardApi.middleware,
      eventApi.middleware,
      searchApi.middleware,
      walletApi.middleware,
      toolsApi.middleware,
      moneyApi.middleware,
      orderApi.middleware,
    ),
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export default store;
